import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatAutocompleteModule} from '@angular/material/autocomplete';

import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatChipsModule} from '@angular/material/chips';
import {MatIconModule} from '@angular/material/icon';
import {EmOperandWithIconModule} from '../operand-with-icon/operand-with-icon.module';
import {TranslateModule} from '@ngx-translate/core';
import {EmCombineAttributesComponent} from './combine-attributes.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    MatChipsModule,
    MatIconModule,
    EmOperandWithIconModule,
  ],
  declarations: [EmCombineAttributesComponent],
  exports: [EmCombineAttributesComponent],
})
export class EmCombineAttributesModule {}
